import React from "react";
import RefereeLottery from "../Controls/RefereeLottery";
import "../Css/Common.css";

const RefereeLotteryPage: React.FunctionComponent = () => {
    return <RefereeLottery />;
};

export default RefereeLotteryPage;
